import { useEffect } from "react";

const SITE = "https://www.freedomtaxfiler.com";

function upsertMeta(attr, key, content) {
    if (!content) return;
    let el = document.head.querySelector(`meta[${attr}="${key}"]`);
    if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
    }
    el.setAttribute("content", content);
}

function upsertLink(rel, href) {
    if (!href) return;
    let el = document.head.querySelector(`link[rel="${rel}"]`);
    if (!el) {
        el = document.createElement("link");
        el.setAttribute("rel", rel);
        document.head.appendChild(el);
    }
    el.setAttribute("href", href);
}

/**
 * Per-route SEO tags without external dependencies (react-helmet-async is
 * unmaintained and breaks under React 19). Safe for bot prerendering: the
 * DOM updates run in the component effect before prerenderers snapshot.
 */
export default function Seo({ title, description, path = "/", noindex = false }) {
    useEffect(() => {
        const full = title || "Freedom Tax Filer | U.S. Tax Preparation Services";
        const desc =
            description ||
            "Freedom Tax Filer — professional U.S. tax preparation for W-2 employees, professionals, gig workers, multi-state filers, and small businesses.";
        document.title = full;
        upsertMeta("name", "description", desc);
        upsertMeta("name", "robots", noindex ? "noindex, nofollow" : "index, follow, max-image-preview:large, max-snippet:-1");
        upsertLink("canonical", SITE + path);
        upsertMeta("property", "og:title", full);
        upsertMeta("property", "og:description", desc);
        upsertMeta("property", "og:url", SITE + path);
        upsertMeta("property", "og:type", "website");
        upsertMeta("property", "og:site_name", "Freedom Tax Filer");
        upsertMeta("property", "og:locale", "en_US");
        upsertMeta("name", "twitter:card", "summary");
        upsertMeta("name", "twitter:title", full);
        upsertMeta("name", "twitter:description", desc);
    }, [title, description, path, noindex]);
    return null;
}
